module.exports = ".item-container {\n  display: inline-block;\n  padding: 10px 10px;\n  border-radius: 3px;\n  -webkit-box-shadow: 2px 2px 5px 2px gray;\n          box-shadow: 2px 2px 5px 2px gray;\n  width: 100%;\n}\n\n.item-title {\n  padding-bottom: 25px;\n  min-height: 17vh;\n  overflow: hidden;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/asset-item/asset-item.component.css
// module id = ./src/app/modules/asset-item/asset-item.component.css
// module chunks = main